export { FooterLink } from "./FooterLink";
export type { FooterLinkType } from "./FooterLink";
